import * as service from './service'
export default {
  namespace: 'walletCashRecord',
  state: {
    detailList: [],
    incomeTypes: []
  },
  effects: {
    * getTransactionsData ({ payload }, { call, put }) {
      const res = yield call(service.getTransactionsData, payload)
      yield put({
        type: 'save',
        payload: {
          detailList: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
